import * as React from "react";
import { makeStyles } from "@material-ui/core";

import { colors, greys } from "@styles/color.styles";
import { fontFamily, fontFamilySans, weight } from "@styles/type.styles";
import { formatNumberAsAbbreviation } from "../overview.util";

export interface HeroStatProps {
  hero: number | null;
  title: string;
  subtitle: React.ReactNode;
}

export const useStyles = makeStyles({
  container: {
    color: colors.blueDusk.darker,
    fontFamily,
    width: "49%",
    marginBottom: 20,
    "@media (min-width: 1030px)": {
      width: "25%",
    },
  },
  hero: {
    fontSize: 40,
    lineHeight: 1.2,
    fontVariantNumeric: "proportional-nums lining-nums",
  },
  title: {
    fontWeight: weight.bold,
    fontSize: 12,
    lineHeight: "14px",
    textTransform: "uppercase",
    marginTop: 8,
  },
  subtitle: {
    fontFamily: fontFamilySans,
    fontWeight: weight.std,
    fontSize: 14,
    lineHeight: "16px",
    color: greys.slate,
    marginTop: 4,
  },
});

export const HeroStat = ({ hero, title, subtitle }: HeroStatProps) => {
  const classes = useStyles();

  const renderHero = () => {
    if (!hero) {
      return "-";
    }

    return formatNumberAsAbbreviation(hero);
  };

  return (
    <div className={classes.container}>
      <div className={classes.hero}>{renderHero()}</div>
      <div className={classes.title}>{title}</div>
      <div className={classes.subtitle}>{subtitle}</div>
    </div>
  );
};
